<template>
  <div class="social-step-editor-sidebar-media-images">
    <p class="social-step-editor-sidebar-media-images__text">
      Get the perfect unique and custom images for your design with the power of AI.
    </p>
    <button
        type="button"
        data-toggle="modal"
        data-target="#smart-image"
        tabindex="-1"
        class="btn btn-sm btn-primary mt-2"
        aria-disabled="false"
        v-text="'Create Image'"
        @click="onStart()"
    />
    <div
        class="modal fade"
        id="smart-image"
        role="dialog"
        aria-labelledby="smart-text"
        aria-hidden="true"
        data-backdrop="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Generate Image (AI)</h4>
          </div>
          <div class="modal-body">
            <div v-if="step === 1">
              <strong>Type in your prompt</strong>
              <p>Describe what you would like in your AI generated picture.</p>
              <div class="px-4">
                <shared-step-editor-input-field
                    :input-value="query"
                    :height="40"
                    label="Prompt"
                    placeholder="Describe in detail what you want the AI to create."
                    class="social-step-editor-sidebar-media-images__search"
                    @input="onType"
                >
                  <template v-slot:prefix>
                    <span v-html="icon" class="social-step-editor-sidebar-media-images__icon"></span>
                  </template>
                </shared-step-editor-input-field>
              </div>
            </div>
            <div v-if="step === 2">
              <div v-if="loading" >
                <strong>Creating prompt suggestions for:</strong>
                <p class="social-step-editor-sidebar-text__textarea mb-4" v-text="query" />
                <span class="loader"></span>
              </div>
              <div v-else>
                <strong>Choose a prompt for creating the image:</strong>
                <button
                    v-for="suggestion in suggestions"
                    class="btn btn-block btn-sm btn-primary text-wrap"
                    @click="onSelectPrompt(suggestion)"
                    v-text="suggestion"
                />
                <button
                    class="btn btn-block btn-sm text-wrap"
                    @click="onSelectPrompt(query)"
                    v-text="query"
                />
              </div>
            </div>
            <div v-else-if="step === 3">
              <strong>Choose a style for:</strong>
              <p v-text="text"/>
              <button
                  v-for="style in styles"
                  class="btn btn-block btn-sm btn-primary"
                  @click="onSearch(style)"
                  v-text="style"
              />
            </div>
            <div v-else-if="step === 4">
              <div v-if="loading" >
                <strong>Generating images...</strong>
                <p v-text="text" />
                <span class="loader"></span>
              </div>
              <div v-else>
                <strong>Select an image</strong>
                <p>Select an image to be used in your social post.</p>
                <div class="row">
                  <div class="col-sm-3 p-2" v-for="image in images">
                    <button
                        class="btn btn-block btn-sm btn-default"
                        data-dismiss="modal"
                        @click="onSelectImage(image)"
                    >
                      <img :src="image" alt="Generated Image">
                      <span class="pt-2">Select</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div v-else-if="step === 5">
              <div v-if="loading" >
                <strong>Selecting image...</strong>
                <p>Please wait</p>
                <span class="loader"></span>
              </div>
              <strong v-else>Image selected!</strong>
            </div>
          </div>
          <div v-if="!loading" class="modal-footer">
            <button v-if="step > 1" type="button" class="btn btn-default" @click="step--">Back</button>
            <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
            <button v-if="step === 1" type="button" class="btn btn-primary" @click="onGetSuggestions">Next</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SharedStepEditorInputField from '../../shared/form/SharedStepEditorInputField';
import LoopSvg from '!!raw-loader!../../../../../../../assets/images/builders/loop.svg';
import SocialStepEditorSidebarMediaImagesMasonry from './SocialStepEditorSidebarMediaImagesMasonry';
import swal from "sweetalert2";

export default {
  components: {
    SharedStepEditorInputField,
    SocialStepEditorSidebarMediaImagesMasonry,
  },
  props: {
    image: String,
  },
  data: () => ({
    query: '',
    loading: false,
    icon: LoopSvg,
    timeout: null,
    step: 1,
    style: null,
    styles: [
        'Photo',
        'Realism',
        'Minimalism',
        'Retro/Vintage',
        'Lettering',
        'Geometric',
        'Vector',
        'Flat Art',
        '3D Illustration',
        'Surrealism',
        'Psychedelic',
    ],
    text: '',
    suggestions: [],
    images: [],
  }),
  methods: {
    onStart() {
      this.step = 1;
    },
    onType(value) {
      this.query = value;
    },
    onGetSuggestions() {
      this.step = 2;
      this.loading = true;
      axios.post(`/api/?entity=smart-images&action=getQuerySuggestions`, { query: this.query })
          .then(this.handleResponse)
          .then((result) => result && (this.suggestions = result.response));
    },
    onSelectPrompt(query) {
      this.step = 3;
      this.text = query;
    },
    onSearch(style) {
      this.step = 4;
      this.loading = true;
      axios.post(`/api/?entity=smart-images&action=generateImage`, { query: this.text + ". " + style })
          .then(this.handleResponse)
          .then((result) => result && (this.images = result.data.map((item) => item.url)));
    },
    onSelectImage(url) {
      this.step = 5;
      this.loading = true;
      axios.post(`/api/?entity=smart-images&action=selectImage`, { url })
          .then(this.handleResponse)
          .then((result) => result && this.$emit('update', result.url))
          .then(() => $("#smart-image").modal('hide'));
    },
    handleResponse(result) {
      this.loading = false;
      if (result.status === 200) {
        return result.data;
      } else {
        $("#smart-image").modal('hide');
        this.step = 1;
        swal.fire({
          title: 'UhOh!',
          text: 'Something went wrong.',
          type: 'error',
          confirmButtonText: 'Ok',
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-lg btn-primary',
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.text-wrap {
  white-space: normal!important;
}
.loader {
  width: 48px;
  height: 48px;
  border: 5px solid #66CCCC;
  border-bottom-color: transparent;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@import '../../../../../../sass/web/_variables.scss';

.social-step-editor-sidebar-media-images {
  padding: 16px;
  width: 100%;
  &__text {
    text-align: center;
    color: $color-gunsmoke;
    font-size: 12px;
    line-height: 16px;
    margin: 16px 0;
  }
  &__icon {
    margin-left: 10px;
    color: inherit;
    display: flex;
  }
}

</style>
